@if (isPotentialCustomer || currentCustomer?.custId) {
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="font-medium">Orders</h5>
    @if (actionsEnabled && !isPotentialCustomer) {
      <div class="d-flex align-items-end">
        <div class="circle mr-2">
          <a
            [href]="environment.apihost + '/api/trading/orders.csv?customerId=' + currentCustomer?.custId"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg class="icon icon-16 text-color-grey">
              <use xlink:href="/assets/img/svgs/svgset.svg#download-redesign-23" />
            </svg>
          </a>
        </div>
        <web-design-system-list-toggle (click)="showOrders = !showOrders" [isCollapsed]="!showOrders" />
      </div>
    }
  </div>
  @if (isPotentialCustomer) {
    Hier werden bald Deine offenen, ausgeführten und gestrichenen Orders gelistet
  }

  @if (!isPotentialCustomer) {
    @if (showOrders) {
      <div class="nav nav-tabs mb-1">
        <div class="nav-item">
          <a
            [id]="orderSelector"
            class="nav-link cursor-pointer"
            [class.active]="orderSelector === 'open'"
            (click)="orderSelector = 'open'"
          >
            offen
          </a>
        </div>
        <div class="nav-item">
          <a
            [id]="orderSelector"
            class="nav-link cursor-pointer"
            [class.active]="orderSelector === 'executed'"
            (click)="orderSelector = 'executed'"
          >
            ausgeführt
          </a>
        </div>
        <div class="nav-item">
          <a
            [id]="orderSelector"
            class="nav-link cursor-pointer"
            [class.active]="orderSelector === 'canceled'"
            (click)="orderSelector = 'canceled'"
          >
            gestrichen
          </a>
        </div>
      </div>
      <div class="flex-grow">
        @if (orderSelector === 'open') {
          <order-zero-open-orders [actionsEnabled]="actionsEnabled" (openOrdersChanged)="reloadPositions.emit()" />
        }
        @if (orderSelector === 'executed') {
          <order-zero-executed-orders [actionsEnabled]="actionsEnabled" />
        }
        @if (orderSelector === 'canceled') {
          <order-zero-canceled-orders [actionsEnabled]="actionsEnabled" />
        }
      </div>
    }
  }
}
